<template lang="pug">
    div.login.box
        img.logo(src="../imgs/icon-logo.png")
        dl
            dt 欢迎您
            dd 让卫星无所不在
        p.desc 使用微信扫码登录
        img.qr(v-if="qr" :src="`https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${qr.ticket}`")

</template>

<script>
import { REQUEST, default as storeMixin } from '../store/mixin.js';
import { clearInterval } from 'timers';

let interval = null;

export default {
    name: 'Login',
    mixins: [storeMixin],
    data() {
        return {
            qr: null,
        };
    },
    async created() {
        await this.getQr();
        this.clear();
        interval = window.setInterval(() => {
            this.checkLogin();
        }, 3000);
    },
    computed: {
        qrUrl() {
            let url = 'v2/user/wechat/qrcode';
            const invitationCode = new URLSearchParams(
                window.location.search
            ).get('ic');

            if (invitationCode) {
                url = `${url}?invitation_code=${invitationCode}`;
            }
            return url;
        },
    },
    methods: {
        clear() {
            try {
                window.clearInterval(interval);
            } catch (e) {
                console.log(e);
            }
        },
        async getQr() {
            const result = await REQUEST({
                url: this.qrUrl,
                noAuth: true,
            });
            this.qr = result.data;
        },
        async checkLogin() {
            const result = await REQUEST({
                method: 'POST',
                url: `v2/user/wechat/login`,
                noAuth: true,
                data: {
                    scene_str: this.qr.scene_str,
                },
            });
            if (result.data.token) {
                this['USER/SET_STATE']({
                    key: 'TOKEN',
                    value: result.data.token,
                });
                window.localStorage.user = JSON.stringify({
                    token: result.data.token,
                    ts: new Date().valueOf(),
                });
                console.log('登录成功');
                this.clear();
                this.$router.push('/');
            }
        },
    },
};
</script>

<style lang="stylus" scoped>
.login
    position absolute
    left 0
    top 0
    height 100vh
    width 100vw
    background #1e1f24 url('../imgs/login-bg.jpg') right bottom no-repeat
    box-sizing border-box
    padding 150px 200px
.logo
    width 130px
    display block
    margin-bottom 20px
dt
    font-size 36px
    font-weight bold
dd
    color #727688
    margin-bottom 40px

.desc
    color #4b5bfb
    border-bottom 1px solid #4b5bfb
    margin-bottom 40px
    padding-bottom 10px
    display inline-block
.qr
    width 256px
    display block
</style>
